import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const RangeSlider = ({ min = 0, max = 1000, initialMin = 191, initialMax = 555 }) => {

    const { t } = useTranslation();

    const [minValue, setMinValue] = useState(initialMin);
    const [maxValue, setMaxValue] = useState(initialMax);
    const [dragging, setDragging] = useState(null);
    const sliderRef = useRef(null);

    const minPercent = ((minValue - min) / (max - min)) * 100;
    const maxPercent = ((maxValue - min) / (max - min)) * 100;

    const handleMouseDown = (type, e) => {
        e.preventDefault();
        setDragging(type);
    };

    const handleMouseMove = (e) => {
        if (!dragging || !sliderRef.current) return;

        const rect = sliderRef.current.getBoundingClientRect();
        const x = Math.min(Math.max(0, e.clientX - rect.left), rect.width);
        const value = min + (x / rect.width) * (max - min);
        const roundedValue = Math.round(value);

        if (dragging === 'min') {
            const newMin = Math.min(roundedValue, maxValue - 1);
            setMinValue(newMin);
        } else if (dragging === 'max') {
            const newMax = Math.max(roundedValue, minValue + 1);
            setMaxValue(newMax);
        }
    };

    const handleMouseUp = () => {
        setDragging(null);
    };

    useEffect(() => {
        if (dragging) {
            window.addEventListener('mousemove', handleMouseMove);
            window.addEventListener('mouseup', handleMouseUp);
        }
        return () => {
            window.removeEventListener('mousemove', handleMouseMove);
            window.removeEventListener('mouseup', handleMouseUp);
        };
    }, [dragging, minValue, maxValue]);

    return (
        <div style={{
            width: '100%',
            maxWidth: '500px',
            padding: '20px',
            fontFamily: 'Arial, sans-serif'
        }}>
            <div style={{ marginBottom: '20px' }}>
                <span style={{ fontSize: '12px', fontWeight: 'bold', color: '#666', letterSpacing: '1px' }}>
                    {t("RANGO DE PRECIOS")}
                </span>
            </div>

            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                gap: '10px',
                marginBottom: '40px'
            }}>
                <span style={{ fontSize: '28px', fontWeight: 'bold' }}>€{minValue}</span>
                <span style={{ fontSize: '24px', color: '#999' }}>-</span>
                <span style={{ fontSize: '28px', fontWeight: 'bold' }}>€{maxValue}</span>
            </div>

            <div
                ref={sliderRef}
                style={{
                    position: 'relative',
                    height: '40px',
                    marginBottom: '20px',
                    cursor: dragging ? 'grabbing' : 'pointer'
                }}
            >
                {/* Fondo */}
                <div style={{
                    position: 'absolute',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    left: 0,
                    right: 0,
                    height: '4px',
                    background: '#e0e0e0',
                    borderRadius: '2px',
                    pointerEvents: 'none'
                }} />

                {/* Rango seleccionado */}
                <div style={{
                    position: 'absolute',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    left: `${minPercent}%`,
                    width: `${maxPercent - minPercent}%`,
                    height: '4px',
                    background: '#007aff',
                    borderRadius: '2px',
                    pointerEvents: 'none'
                }} />

                {/* Thumb mínimo */}
                <div
                    style={{
                        position: 'absolute',
                        top: '50%',
                        transform: 'translate(-50%, -50%)',
                        left: `${minPercent}%`,
                        width: '20px',
                        height: '20px',
                        background: 'white',
                        border: '2px solid #007aff',
                        borderRadius: '50%',
                        cursor: 'grab',
                        boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
                        zIndex: 10
                    }}
                    onMouseDown={(e) => handleMouseDown('min', e)}
                />

                {/* Thumb máximo */}
                <div
                    style={{
                        position: 'absolute',
                        top: '50%',
                        transform: 'translate(-50%, -50%)',
                        left: `${maxPercent}%`,
                        width: '20px',
                        height: '20px',
                        background: 'white',
                        border: '2px solid #007aff',
                        borderRadius: '50%',
                        cursor: 'grab',
                        boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
                        zIndex: 10
                    }}
                    onMouseDown={(e) => handleMouseDown('max', e)}
                />
            </div>

            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span style={{ fontSize: '14px', color: '#666' }}>€{min}</span>
                <span style={{ fontSize: '14px', color: '#666' }}>€{max}</span>
            </div>
        </div>
    );
};

export default RangeSlider;
